"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameEpic = void 0;
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _Core = _interopRequireDefault(require("../Core"));
var _types = require("../com/types");
var _types2 = require("../game/types");
var _types3 = require("../ui/types");
var _RoundState = require("../enums/RoundState");
var _types4 = require("../config/types");
var _types5 = require("../blitz/types");
var _types6 = require("../autoPlay/types");
var _actions = require("../bet/actions");
var _DialogState = require("../../../ui/enums/DialogState");
var _currencyFormatter = require("../../../utils/currencyFormatter");
var _logger = _interopRequireDefault(require("../../../utils/logger"));
var _CommandType = require("../../dovahzul/CommandType");
var _AckRequest = require("../../dovahzul/requests/AckRequest");
var _CollectRequest = require("../../dovahzul/requests/CollectRequest");
var _KeepAliveRequest = require("../../dovahzul/requests/KeepAliveRequest");
var _SpinRequest = require("../../dovahzul/requests/SpinRequest");
var _types7 = require("../balance/types");
var _FeatureAwardType = require("../enums/FeatureAwardType");
var _types8 = require("../bet/types");
var _DetermineIfNewRoundCanBestarted = require("../../common/helpers/DetermineIfNewRoundCanBestarted");
var _actions2 = require("../com/actions");
var _ContinueRequest = require("../../dovahzul/requests/ContinueRequest");
var _ReelState = require("../enums/ReelState");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GameEpic = exports.GameEpic = /*#__PURE__*/_createClass(function GameEpic() {
  var _this = this;
  _classCallCheck(this, GameEpic);
  /**
   * during spin, if we dont get reel response before this time the connection issue icon will flash.
   * MS
   */
  _defineProperty(this, "SLOW_SERVER_RESPONSE_TIMEOUT", 8000);
  _defineProperty(this, "getEpic", function () {
    return (0, _reduxObservable.combineEpics)(_this.gameVoid, _this.commandEndRound, _this.commandWinLine, _this.commandWinLineEnd, _this.commandFeatureEnd, _this.commandFeature, _this.commandFeatureCustom, _this.commandSetReels, _this.commandSpinEnd, _this.keepAliveStart, _this.spinButtonInsufficientBalance, _this.spinButtonPresentationStop, _this.spinButtonQuickStop, _this.startRoundEpic, _this.commandSpinResponse, _this.commandRoundStartResponse, _this.commandSpinStopHandler, _this.reelsSpin, _this.gameReady, _this.setSavedReels, _this.commandUnfinishedGame, _this.unfinishedFeature, _this.onIdle, _this.maxWin, _this.updateCollectionOnBet, _this.collectionsHandling, _this.commandCustom, _this.resumeGameResponse, _this.winLinePresentationStop, _this.commandContinueWait, _this.hyperSpinStart, _this.onLockStopAll);
  });
  _defineProperty(this, "onLockStopAll", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.LOCK),
    //   filter(() => store.value.blitz.on),
    (0, _operators.mergeMap)(function () {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types5.BLITZ_PLAY_STOP
      }), (0, _rxjs.of)({
        type: _types6.AUTO_PLAY_STOP
      }));
    }));
  });
  _defineProperty(this, "gameVoid", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.ROUND_VOID), (0, _operators.filter)(function () {
      return !store.value.blitz.on;
    }), (0, _operators.mergeMap)(function () {
      return (0, _rxjs.from)(_Core["default"].gameController.reset()).pipe((0, _operators.mergeMap)(function () {
        return _rxjs.EMPTY;
      }));
    }));
  });
  /**
   * Fired when game is ready to play, used for greetings start sounds etc. If splash is on it fires after splash has been hidden
   * Can only ever fire once.
   *
   * WARNING, there is a bug where this can be called before controller is innitiated. to counter it, we check that game controller has been set
   */
  _defineProperty(this, "gameReady", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.GAME_READY, _types4.HIDE_SPLASH_SCREEN), (0, _operators.filter)(function () {
      return !store.value.config.splashScreen && !!_Core["default"].gameController;
    }), (0, _operators.take)(1), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.from)(_Core["default"].gameController.gameReady()).pipe((0, _operators.mergeMap)(function () {
        return _rxjs.EMPTY;
      }));
    }));
  });
  _defineProperty(this, "commandWinLineEnd", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return !store.value.blitz.on && (_CommandType.CommandType.PayLineEndResponse === a.payload.type || _CommandType.CommandType.PayWayEndResponse === a.payload.type);
    }), (0, _operators.switchMap)(function (a) {
      return (0, _rxjs.from)(_Core["default"].gameController.winLinePresentationEnd(store.value.game.featureFreeSpins)).pipe((0, _operators.mergeMap)(function () {
        return (0, _rxjs.of)({
          type: _types.COMMAND_QUEUE_NEXT
        });
      }));
    }));
  });
  _defineProperty(this, "commandContinueWait", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return a.payload.type == _CommandType.CommandType.ContinueWaitResponse;
    }), (0, _operators.mergeMap)(function () {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types.COMMAND_QUEUE_NEXT
      }), (0, _rxjs.of)((0, _actions2.SendCommand)(new _ContinueRequest.ContinueRequest())));
    }));
  });
  _defineProperty(this, "commandCustom", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return a.payload.type > 4999 || a.payload.type == _CommandType.CommandType.PlayerActionResponse;
    } // this is a quick fix. not many games has it.
    ), (0, _operators.switchMap)(function (a) {
      return (0, _rxjs.from)(_Core["default"].gameController.customCommand(a.payload)).pipe((0, _operators.mergeMap)(function () {
        return (0, _rxjs.of)({
          type: _types.COMMAND_QUEUE_NEXT
        });
      }));
    }));
  });
  _defineProperty(this, "commandSpinEnd", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return !store.value.blitz.on && _CommandType.CommandType.SpinEndResponse === a.payload.type;
    }), (0, _operators.switchMap)(function (a) {
      return (0, _rxjs.from)(_Core["default"].gameController.spinEnd(store.value.game.featureFreeSpins)).pipe((0, _operators.mergeMap)(function () {
        return (0, _rxjs.of)({
          type: _types2.SPIN_END
        }, {
          type: _types.COMMAND_QUEUE_NEXT
        });
      }));
    }));
  });
  _defineProperty(this, "commandWinLine", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return !store.value.blitz.on && (_CommandType.CommandType.PayLineWinResponse === a.payload.type || _CommandType.CommandType.PayWayWinResponse === a.payload.type);
    }), (0, _operators.switchMap)(function (a) {
      var command = a.payload;
      var actions = [(0, _rxjs.of)({
        type: _types2.PAYLINE_WIN,
        payload: command
      })];
      var returnActions = [(0, _rxjs.of)({
        type: _types.COMMAND_QUEUE_NEXT
      })];

      // Check max win and dispatch win counter update.
      var newValue = store.value.game.winCounter + a.payload.coinsWon;
      if (store.value.config.maxWin && store.value.config.maxWin <= newValue) {
        actions.push((0, _rxjs.of)({
          type: _types2.GAME_WINCOUNTER_SET,
          payload: store.value.config.maxWin
        }));
        returnActions = [(0, _rxjs.of)({
          type: _types2.GAME_MAX_WIN
        })];
      } else {
        actions.push((0, _rxjs.of)({
          type: _types2.GAME_WINCOUNTER_SET,
          payload: newValue
        }));
      }
      if (!store.value.game.presentationStop) {
        // Regular show
        actions.push((0, _rxjs.race)((0, _rxjs.from)(_Core["default"].gameController.showWinLine(command, store.value.game.featureFreeSpins)), action$.pipe((0, _reduxObservable.ofType)(_types2.PRESENTATION_STOP), (0, _operators.take)(1))).pipe((0, _operators.mergeMap)(function () {
          return _rxjs.concat.apply(void 0, _toConsumableArray(returnActions));
        })));
      } else {
        // Instant Show
        _Core["default"].gameController.showWinLineInstant(command, store.value.game.featureFreeSpins);
        actions.push.apply(actions, _toConsumableArray(returnActions));
      }
      return _rxjs.concat.apply(void 0, actions);
    }));
  });
  _defineProperty(this, "commandFeatureEnd", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return !store.value.blitz.on && _CommandType.CommandType.FeatureEndResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function (a) {
      var base = [(0, _rxjs.of)({
        type: _types2.GAME_FEATURE_END,
        payload: {
          type: a.payload.awardType
        }
      }), (0, _rxjs.of)({
        type: _types.COMMAND_QUEUE_NEXT
      })];
      switch (a.payload.awardType) {
        case _FeatureAwardType.FeatureAwardType.FreeSpins:
          {
            //Last one. stop doing keep alive, also end any ongoing hyperspin touch event
            if (store.value.game.featureFreeSpinsTriggerCount == 1) {
              base.push((0, _rxjs.of)({
                type: _types2.KEEP_ALIVE_STOP
              }), (0, _rxjs.of)({
                type: _types2.HYPER_SPIN_STOP
              }));
            }
            return (0, _rxjs.from)(_Core["default"].gameController.onFreeSpinEnd(store.value.game.featureFreeSpinsTriggerCount)).pipe((0, _operators.mergeMap)(function () {
              return _rxjs.concat.apply(void 0, base);
            }));
          }
        case _FeatureAwardType.FeatureAwardType.TurnWildSymbol:
        case _FeatureAwardType.FeatureAwardType.Respin:
          {
            // dont really do anything,WE HAVE TO HANDLE EACH FEATURE END HER,
            return _rxjs.concat.apply(void 0, base);
          }
        default:
          {
            // NEW DEFAULT HANDLING, cant remove other untill it has been tested.
            if (a.payload.awardType >= 5000 || a.payload.awardType == _FeatureAwardType.FeatureAwardType.GridWin) {
              return (0, _rxjs.from)(_Core["default"].gameController.onFeatureEnd(a.payload)).pipe((0, _operators.mergeMap)(function () {
                return _rxjs.concat.apply(void 0, base);
              }));
            }

            // Check max win and dispatch win counter update.
            // TODO! DONT STORE IN STORE LIKE THIS SUPER DANGEROUS WITH NESTED FEATURES
            var newValue = store.value.game.winCounter + store.value.game.featureCoinsWon;
            if (store.value.config.maxWin && store.value.config.maxWin <= newValue) {
              return (0, _rxjs.concat)((0, _rxjs.of)({
                type: _types2.GAME_FEATURE_END,
                payload: {
                  type: a.payload.awardType
                }
              }), (0, _rxjs.of)({
                type: _types2.GAME_WINCOUNTER_SET,
                payload: store.value.config.maxWin
              }), (0, _rxjs.of)({
                type: _types2.GAME_MAX_WIN
              }), (0, _rxjs.of)({
                type: _types2.KEEP_ALIVE_STOP
              }) // this prevents keep alive to get stuck after a max win.
              );
            } else if (store.value.config.coinsFeatureAsPayline) {
              return _rxjs.concat.apply(void 0, base);
            } else {
              return _rxjs.concat.apply(void 0, base.concat([(0, _rxjs.of)({
                type: _types2.GAME_WINCOUNTER_SET,
                payload: newValue
              })]));
            }
          }
      }
    }));
  });
  /**
   * 
   * Not this runs even when blitzing
   * @param action$ 
   * @returns 
   */
  _defineProperty(this, "commandSetReels", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.SetReelsResponse === a.payload.type && !!_Core["default"].gameController.setReels;
    }), (0, _operators.mergeMap)(function (a) {
      var base = (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types2.SET_REELS,
        payload: a.payload.reels
      }), (0, _rxjs.of)({
        type: _types.COMMAND_QUEUE_NEXT
      }));
      return (0, _rxjs.from)(_Core["default"].gameController.setReels(a.payload)).pipe((0, _operators.mergeMap)(function () {
        return base;
      }));
    }));
  });
  _defineProperty(this, "keepAliveStart", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.KEEP_ALIVE_START), (0, _operators.filter)(function (a) {
      return !!store.value.config.keepAliveInterval && !store.value.game.keepingAlive;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types2.KEEP_ALIVE_STARTED
      }), (0, _rxjs.interval)(store.value.config.keepAliveInterval).pipe((0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types2.KEEP_ALIVE_STOP))), (0, _operators.mapTo)({
        type: _types.COMMAND_SEND,
        payload: new _KeepAliveRequest.KeepAliveRequest()
      })));
    }));
  });
  _defineProperty(this, "commandFeature", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return !store.value.blitz.on && _CommandType.CommandType.FeatureWinResponse === a.payload.type && a.payload.awardType < 5000;
    }), (0, _operators.switchMap)(function (a) {
      var command = a.payload;
      var actions = [(0, _rxjs.of)({
        type: _types2.GAME_FEATURE_START,
        payload: {
          type: command.awardType,
          amount: command.amount,
          coinsWon: command.coinsWon
        }
      })];
      //console.log(command)
      switch (command.awardType) {
        case _FeatureAwardType.FeatureAwardType.Respin:
          actions.push((0, _rxjs.from)(_Core["default"].gameController.onReSpinStart(command)).pipe((0, _operators.mergeMap)(function () {
            return (0, _rxjs.from)(_Core["default"].gameController.reSpinReel(command.index)).pipe(
            // note we do not send feature end here or in the free spin handler.
            // we set the reel to be in spinning state so that the spin if not spinning does not fire.
            (0, _operators.mergeMap)(function () {
              return (0, _rxjs.concat)((0, _rxjs.of)({
                type: _types2.QUICK_STOP_AVAILABLE
              }), (0, _rxjs.of)({
                type: _types2.REELS_SPINNING
              }), (0, _rxjs.of)({
                type: _types.COMMAND_QUEUE_NEXT
              }));
            }));
          })));
          break;
        case _FeatureAwardType.FeatureAwardType.FreeSpins:
          actions.push((0, _rxjs.of)({
            type: _types2.KEEP_ALIVE_START
          }));
          actions.push((0, _rxjs.of)({
            type: _types2.HYPER_SPIN_STOP
          }));
          actions.push((0, _rxjs.of)({
            type: _types2.FREE_SPINS_WON,
            payload: command.amount
          }));
          actions.push((0, _rxjs.from)(_Core["default"].gameController.onFreeSpinStart(store.value.game.featureFreeSpinsTriggerCount + 1, false, command.amount, command)).pipe((0, _operators.mergeMap)(function () {
            return (0, _rxjs.of)({
              type: _types.COMMAND_QUEUE_NEXT
            });
          })));
          break;
        case _FeatureAwardType.FeatureAwardType.Coins:
          // this makes the result of the feature shown instantly. not after the controller has resolved the promise.
          // it also handles presentation_stop request.
          // win will also count as "payline win" in the state.
          if (store.value.config.coinsFeatureAsPayline) {
            var newValue = store.value.game.winCounter + command.coinsWon;
            return _rxjs.concat.apply(void 0, actions.concat([(0, _rxjs.of)({
              type: _types2.GAME_COUNT_FEATURE_AS_LINE,
              payload: command.coinsWon
            }), (0, _rxjs.of)({
              type: _types2.GAME_WINCOUNTER_SET,
              payload: newValue
            }), (0, _rxjs.race)(
            // if presentation finish and the full duration is displayed.
            (0, _rxjs.from)(_Core["default"].gameController.featureCoins(command, a.payload.RESENT)),
            // or if PRESENTATION_STOP happens first. similar to how paylines work.
            action$.pipe((0, _reduxObservable.ofType)(_types2.PRESENTATION_STOP), (0, _operators.take)(1))).pipe((0, _operators.mergeMap)(function () {
              return (0, _rxjs.of)({
                type: _types.COMMAND_QUEUE_NEXT
              });
            }))]));
          }
          actions.push((0, _rxjs.from)(_Core["default"].gameController.featureCoins(command)).pipe((0, _operators.mergeMap)(function () {
            return (0, _rxjs.of)({
              type: _types.COMMAND_QUEUE_NEXT
            });
          })));
          break;
        case _FeatureAwardType.FeatureAwardType.ExpandingSymbolSelect:
          actions.push((0, _rxjs.from)(_Core["default"].gameController.expandingSymbolCollect(command)).pipe((0, _operators.mergeMap)(function () {
            return (0, _rxjs.concat)(
            //  of({ type: REELS_SPIN }), WHAT? why???? // there might be a race condition where it starts after stop if we do no emit this here.
            (0, _rxjs.of)({
              type: _types.COMMAND_QUEUE_NEXT
            }));
          })));
          break;
        case _FeatureAwardType.FeatureAwardType.SpinExpandingSymbolSelect:
          actions.push((0, _rxjs.from)(_Core["default"].gameController.spinExpandingSymbolCollect(command)).pipe((0, _operators.mergeMap)(function () {
            return (0, _rxjs.concat)(
            //  of({ type: REELS_SPIN }), WHAT? why???? // there might be a race condition where it starts after stop if we do no emit this here.
            (0, _rxjs.of)({
              type: _types.COMMAND_QUEUE_NEXT
            }));
          })));
          break;
        case _FeatureAwardType.FeatureAwardType.ExpandingSymbol:
          actions.push((0, _rxjs.from)(_Core["default"].gameController.expandingSymbol(command)).pipe((0, _operators.mergeMap)(function () {
            return (0, _rxjs.of)({
              type: _types.COMMAND_QUEUE_NEXT
            });
          })));
          break;
        case _FeatureAwardType.FeatureAwardType.WinMultiplier:
          actions.push((0, _rxjs.of)({
            type: _types6.AUTO_PLAY_STOP_HIDE
          }));
          actions.push((0, _rxjs.from)(_Core["default"].gameController.winMultiplier(command)).pipe((0, _operators.mergeMap)(function () {
            return (0, _rxjs.concat)((0, _rxjs.of)({
              type: _types.COMMAND_QUEUE_NEXT
            }), (0, _rxjs.of)({
              type: _types6.AUTO_PLAY_STOP_SHOW
            }));
          })));
          break;
        case _FeatureAwardType.FeatureAwardType.CoinsMultiplier:
          actions.push((0, _rxjs.of)({
            type: _types6.AUTO_PLAY_STOP_HIDE
          }));
          actions.push((0, _rxjs.from)(_Core["default"].gameController.coinMultiplier(command)).pipe((0, _operators.mergeMap)(function () {
            return (0, _rxjs.concat)((0, _rxjs.of)({
              type: _types.COMMAND_QUEUE_NEXT
            }), (0, _rxjs.of)({
              type: _types6.AUTO_PLAY_STOP_SHOW
            }));
          })));
          break;
        case _FeatureAwardType.FeatureAwardType.Collect:
          // update the current collection based on current bet.
          // note we cant use the store value here. since it will be updated in the wrong sequenec.e...
          var currentCollection;
          for (var i = 0; i < a.payload.collections.length; i++) {
            if (store.value.bet.value === a.payload.collections[i].betAmount) {
              currentCollection = a.payload.collections[i];
            }
          }
          actions.push((0, _rxjs.from)(_Core["default"].gameController.collect(command, currentCollection)).pipe((0, _operators.mergeMap)(function () {
            return (0, _rxjs.concat)((0, _rxjs.of)({
              type: _types.COMMAND_QUEUE_NEXT
            }));
          })));
          break;
        case _FeatureAwardType.FeatureAwardType.CollectReward:
          actions.push((0, _rxjs.from)(_Core["default"].gameController.collectReward(command)).pipe((0, _operators.mergeMap)(function () {
            return (0, _rxjs.of)({
              type: _types.COMMAND_QUEUE_NEXT
            });
          })));
          break;
        case _FeatureAwardType.FeatureAwardType.AdditionalFreespins:
          actions.push((0, _rxjs.of)({
            type: _types2.FREE_SPINS_WON,
            payload: command.amount
          }), (0, _rxjs.from)(_Core["default"].gameController.AdditionalFreespins(command)).pipe((0, _operators.mergeMap)(function () {
            return (0, _rxjs.of)({
              type: _types.COMMAND_QUEUE_NEXT
            });
          })));
          break;
        /// new default handling. same as custom features. Note this is not fired during blitz. custom features ARE fired during blitz.
        default:
          actions.push((0, _rxjs.of)(command), (0, _rxjs.from)(_Core["default"].gameController.onFeature(command)).pipe((0, _operators.mergeMap)(function () {
            return (0, _rxjs.of)({
              type: _types.COMMAND_QUEUE_NEXT
            });
          })));
          break;
      }
      return _rxjs.concat.apply(void 0, actions);
    }));
  });
  _defineProperty(this, "commandFeatureCustom", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.FeatureWinResponse === a.payload.type && a.payload.awardType >= 5000;
    }), (0, _operators.switchMap)(function (a) {
      var command = a.payload;
      return (0, _rxjs.concat)((0, _rxjs.of)(command), (0, _rxjs.from)(_Core["default"].gameController.onFeature(command, store.value.blitz.on)).pipe((0, _operators.mergeMap)(function () {
        return (0, _rxjs.of)({
          type: _types.COMMAND_QUEUE_NEXT
        });
      })));
    }));
  });
  _defineProperty(this, "commandEndRound", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return !store.value.blitz.on && _CommandType.CommandType.RoundEndResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.from)(_this._checkBigWin(a.payload.totalCoinsWon, store.value.bet.coinValue, store.value.config.bigwin)).pipe((0, _operators.mergeMap)(function () {
        return (0, _rxjs.concat)(
        // To be changed when we support gamble. this is to tell server we got and showed the result
        (0, _rxjs.of)({
          type: _types2.TOTAL_WIN_FORMATED,
          payload: (0, _currencyFormatter.currencyFormatter)(store.value.bet.denomination * a.payload.totalCoinsWon, store.value.balance.currency, store.value.config.locale)
        }), (0, _rxjs.of)({
          type: _types.COMMAND_SEND,
          payload: new _CollectRequest.CollectRequest()
        }), (0, _rxjs.of)({
          type: _types2.ROUND_END,
          payload: {
            totalCoinsWon: a.payload.totalCoinsWon,
            totalWon: store.value.bet.denomination * a.payload.totalCoinsWon
          }
        }), (0, _rxjs.from)(_Core["default"].gameController.onRoundEnd(store.value.replay.playingReplay)).pipe((0, _operators.mergeMap)(function () {
          return (0, _rxjs.of)({
            type: _types.COMMAND_QUEUE_NEXT
          });
        })),
        // WARNING THis has to be last or wierd delays can occur on the pacakges after.
        (0, _rxjs.of)({
          type: _types2.IDLE
        }).pipe((0, _operators.delay)(store.value.config.idleTime),
        // added round start here else idle can fire during features buys...
        (0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types3.SPIN_BUTTON, _types2.ROUND_START)))));
      }));
    }));
  });
  /**
   * on Idle
   */
  _defineProperty(this, "onIdle", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.IDLE), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.from)(_Core["default"].gameController.onIdle()).pipe((0, _operators.mergeMap)(function () {
        return _rxjs.EMPTY;
      }));
    }));
  });
  /**
   * on Spin response, issue set reels to set reel result in store.
   */
  _defineProperty(this, "commandSpinResponse", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.SpinResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function (a) {
      // we confirm the bet size based on what the server actually played the round on
      // this protects us if for any reason the client switched back to default but such as after a promotion.
      // happens with double fires!!!!
      var c = a.payload;

      //validate, none of these are allowed to be 0 or undefined
      // if we have the correct ones we dont send it, this due to issues with info screens.
      if (!c.coins || !c.denomination || !c.payLines || store.value.bet.coins == c.coins && store.value.bet.lines == c.payLines && store.value.bet.denomination == c.denomination) return (0, _rxjs.of)({
        type: _types2.SET_REELS,
        payload: c.reels
      });

      /** think this is used for reconnects to set the correct bet config on spinResponse. */
      return (0, _rxjs.concat)((0, _rxjs.of)((0, _actions.updateBet)({
        lines: c.payLines,
        denomination: c.denomination,
        coins: c.coins
      })), (0, _rxjs.of)({
        type: _types2.SET_REELS,
        payload: c.reels
      }));
    }));
  });
  /**
   * Capture the round id
   */
  _defineProperty(this, "commandRoundStartResponse", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.RoundStartResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types2.SET_ROUND_ID,
        payload: a.payload.roundId
      }), (0, _rxjs.from)(_Core["default"].gameController.onRoundStart()).pipe((0, _operators.mergeMap)(function () {
        return (0, _rxjs.of)({
          type: _types.COMMAND_QUEUE_NEXT
        });
      })));
    }));
  });
  /**
   * on Spin response, issue set reels to set reel result in store. Le
   */
  _defineProperty(this, "commandUnfinishedGame", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.UnfinishedGameResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types2.ROUND_START
      }), (0, _rxjs.of)({
        type: _types2.UNFINISHED_FEATURE,
        payload: {
          awardType: a.payload.awardType,
          freeSpinsPlayed: a.payload.freeSpinsPlayed,
          freeSpinsWon: a.payload.freeSpinsWon,
          triggerCount: a.payload.triggerCount,
          coinsWon: a.payload.coinsWon,
          roundId: a.payload.roundId,
          expandingSymbol: a.payload.expandingSymbol,
          triggerSymbolId: a.payload.triggerSymbolId
        }
      }), (0, _rxjs.of)({
        type: _types3.REQUEST_DIALOG_STATE_ACTIONS,
        payload: {
          state: _DialogState.DialogState.UNFINISHED_GAME,
          actions: {
            DIALOG_OK: [{
              type: _types.COMMAND_QUEUE_NEXT
            }]
          }
        }
      }));
    }));
  });
  /**
   * Resuming game, for Game2 games.
   */
  _defineProperty(this, "resumeGameResponse", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.ResumeGameResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types2.ROUND_START
      }), (0, _rxjs.of)({
        type: _types3.REQUEST_DIALOG_STATE_ACTIONS,
        payload: {
          state: _DialogState.DialogState.UNFINISHED_GAME,
          actions: {
            DIALOG_OK: [{
              type: _types.COMMAND_QUEUE_NEXT
            }]
          }
        }
      }));
    }));
  });
  /**
   * on Spin response, issue set reels to set reel result in store.
   */
  _defineProperty(this, "unfinishedFeature", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.UNFINISHED_FEATURE), (0, _operators.mergeMap)(function (a) {
      var command = a.payload;
      switch (command.awardType) {
        case _FeatureAwardType.FeatureAwardType.FreeSpins:
          {
            return (0, _rxjs.concat)((0, _rxjs.of)({
              type: _types5.BLITZ_MODE_OFF
            }), (0, _rxjs.from)(_Core["default"].gameController.onFreeSpinStart(command.triggerCount, true, null, command)).pipe((0, _operators.mergeMap)(function () {
              return _rxjs.EMPTY;
            })));
          }
        default:
          {
            return _rxjs.EMPTY;
          }
      }
    }));
  });
  /**
   * Set the latest reels response, used when exiting blitz.
   */
  _defineProperty(this, "setSavedReels", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.SET_SAVED_REELS), (0, _operators.filter)(function () {
      return !!store.value.game.reels;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.from)(_Core["default"].gameController.setReels({
        reels: store.value.game.reels,
        type: _CommandType.CommandType.SetReelsResponse
      })).pipe((0, _operators.mergeMap)(function (a) {
        return _rxjs.EMPTY;
      }));
    }));
  });
  _defineProperty(this, "commandSpinStopHandler", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return !store.value.blitz.on && _CommandType.CommandType.SpinResponse === a.payload.type;
    }), (0, _operators.switchMap)(function (a) {
      // debugReelResult(a.payload.reels)

      var freeSpin = false;
      var reSpin = false;
      var ms = 0;
      var startTime = store.value.game.started ? store.value.game.started.getTime() : new Date().getTime();

      // If Respin make custom config
      if (store.value.game.featureReSpin) {
        ms = store.value.config.spinDurationRespin - (new Date().getTime() - startTime);
        reSpin = true;
      }
      // if free spin
      else if (store.value.game.featureFreeSpins) {
        // start time is not really reelevant for freespins. swe have a fixced time for this. Quickstop handles faster stops
        ms = store.value.config.spinDurationFreespin;
        freeSpin = true;
        // if autoplay is on, we dont stop for manual free spins.
        if (store.value.config.manualFreeSpins && !store.value.autoPlay.on) {
          // when its free spins and its "manualfreespin/krieger mode." a pending spin, we wait for spin result. then we hold waitin for spin button press.
          // on press we issue the spin.
          return (0, _rxjs.concat)((0, _rxjs.of)({
            type: _types2.GAME_PLAYER_INPUT_WAIT
          }), action$.pipe((0, _reduxObservable.ofType)(_types3.SPIN_BUTTON), (0, _operators.take)(1), (0, _operators.mergeMap)(function () {
            return (0, _rxjs.concat)((0, _rxjs.of)({
              type: _types2.GAME_PLAYER_INPUT
            }), (0, _rxjs.of)({
              type: _types2.REELS_SPIN
            }),
            // we assume reels are not spinning when its free spin
            (0, _rxjs.of)({
              type: _types2.SET_SPIN_STOP_WAIT,
              payload: {
                ms: ms,
                result: a.payload.reels
              }
            }), (0, _rxjs.race)(
            // Wait the minimum time
            (0, _rxjs.of)(_rxjs.EMPTY).pipe((0, _operators.delay)(ms)),
            // If quick stop is triggered. we still need to enforce minimum time.
            action$.pipe((0, _reduxObservable.ofType)(_types2.QUICK_STOP), (0, _operators.mergeMap)(function () {
              var timeLeft = store.value.config.spinDurationMin - (new Date().getTime() - startTime);
              var ms = timeLeft > 20 ? timeLeft : 20; // we do 0, it might stop before spin started... RC.
              return (0, _rxjs.of)(_rxjs.EMPTY).pipe((0, _operators.delay)(ms));
            }), (0, _operators.take)(1)))
            // when either completes. proceed stopping.
            .pipe((0, _operators.mergeMap)(function () {
              return (0, _rxjs.concat)((0, _rxjs.of)({
                type: _types2.REELS_STOPPING
              }),
              // not a fan of having this here...
              (0, _rxjs.from)(_Core["default"].gameController.stop(a.payload.reels, true, false, store.value.game.quickStop, store.value.game.reconnectSpin)).pipe((0, _operators.mergeMap)(function () {
                return (0, _rxjs.concat)((0, _rxjs.of)({
                  type: _types.COMMAND_SEND,
                  payload: new _AckRequest.AckRequest()
                }), (0, _rxjs.of)({
                  type: _types2.REELS_STOPPED,
                  payload: a.payload.reels
                }, {
                  type: _types2.FREE_SPIN_PLAYED
                }, {
                  type: _types.COMMAND_QUEUE_NEXT
                }));
              })));
            })));
          })));
        }
      }
      // If Regular spin and/or respin
      else {
        var time = store.value.config.spinDuration;

        // if fast play, or quick stop was triggered before we got result
        if (store.value.config.fastPlay || store.value.game.quickStop) time = 0;

        // ensure min spin time is always enforced, despite fast play/quick stop.
        if (time < store.value.config.spinDurationMin) time = store.value.config.spinDurationMin;

        //deduct time already passed.
        ms = time - (new Date().getTime() - startTime);
      }
      var actions = [(0, _rxjs.of)({
        type: _types2.SET_SPIN_STOP_WAIT,
        payload: {
          ms: ms,
          result: a.payload.reels
        }
      })];

      // If we get a SpinResponse Command (such as with free spins) and we are not spinning, call spin.
      if (store.value.game.reelState === _ReelState.ReelState.Stopped) {
        actions.push((0, _rxjs.of)({
          type: _types2.REELS_SPIN
        }));
      }

      // MS CAN NOT BE NEGATIVE,if it is we will wait negative...
      // 20 would be minimum, there is a race condition risk else.??
      // reason is that timelines on spinners dont have a time to start if before.
      // THIS IS CRITICAL, removing the 20 ms will break reconnects at the very least
      ms = ms < 20 ? 20 : ms;
      _logger["default"].debug("GAMEEPIC | spin stop in: " + ms);
      return _rxjs.concat.apply(void 0, actions.concat([(0, _rxjs.race)(
      // Wait the minimum time
      (0, _rxjs.of)(_rxjs.EMPTY).pipe((0, _operators.delay)(ms)),
      // If quick stop is triggered. we still need to enforce minimum time.
      action$.pipe((0, _reduxObservable.ofType)(_types2.QUICK_STOP), (0, _operators.mergeMap)(function () {
        var timeLeft = store.value.config.spinDurationMin - (new Date().getTime() - startTime);
        var ms = timeLeft > 0 ? timeLeft : 0;
        return (0, _rxjs.of)(_rxjs.EMPTY).pipe((0, _operators.delay)(ms));
      }), (0, _operators.take)(1)))
      // when either completes. proceed stopping.
      .pipe((0, _operators.mergeMap)(function () {
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types2.REELS_STOPPING
        }), (0, _rxjs.from)(_Core["default"].gameController.stop(a.payload.reels, freeSpin, reSpin, store.value.game.quickStop, store.value.game.reconnectSpin)).pipe((0, _operators.mergeMap)(function () {
          if (store.value.game.featureReSpin) {
            return (0, _rxjs.from)(_Core["default"].gameController.onReSpinEnd()).pipe((0, _operators.mergeMap)(function () {
              return (0, _rxjs.of)({
                type: _types.COMMAND_SEND,
                payload: new _AckRequest.AckRequest()
              }, {
                type: _types2.REELS_STOPPED,
                payload: a.payload.reels
              }, {
                type: _types2.RESPIN_PLAYED
              }, {
                type: _types.COMMAND_QUEUE_NEXT
              });
            }));
          } else if (store.value.game.featureFreeSpins) {
            return (0, _rxjs.concat)((0, _rxjs.of)({
              type: _types.COMMAND_SEND,
              payload: new _AckRequest.AckRequest()
            }), (0, _rxjs.of)({
              type: _types2.REELS_STOPPED,
              payload: a.payload.reels
            }, {
              type: _types2.FREE_SPIN_PLAYED
            }, {
              type: _types.COMMAND_QUEUE_NEXT
            }));
          } else {
            return (0, _rxjs.of)({
              type: _types2.REELS_STOPPED,
              payload: a.payload.reels
            }, {
              type: _types.COMMAND_QUEUE_NEXT
            });
          }
        })));
      }))]));
    }));
  });
  _defineProperty(this, "spinButtonPresentationStop", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.SPIN_BUTTON), (0, _operators.filter)(function () {
      return store.value.game.presentationStopAvailable;
    }), (0, _operators.mapTo)({
      type: _types2.PRESENTATION_STOP
    }));
  });
  _defineProperty(this, "spinButtonQuickStop", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.SPIN_BUTTON), (0, _operators.filter)(function () {
      return store.value.game.quickStopAvailable;
    }), (0, _operators.mergeMap)(function () {
      var actions = [(0, _rxjs.of)({
        type: _types2.QUICK_STOP
      })];
      if (store.value.game.reelControl == _types2.ReelControlState.Stopping) {
        actions.push((0, _rxjs.from)(_Core["default"].gameController.quickStop()).pipe((0, _operators.mergeMap)(function (b) {
          return _rxjs.EMPTY;
        })));
      }
      return _rxjs.concat.apply(void 0, actions);
    }));
  });
  _defineProperty(this, "spinButtonInsufficientBalance", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.SPIN_BUTTON), (0, _operators.filter)(function (a) {
      return !store.value.blitz.on && store.value.game.gameReady && !store.value.promotion.on && !store.value.config.promoGame && !(store.value.game.roundState === _RoundState.RoundState.Started) && store.value.balance.balance && store.value.bet.centValue > store.value.balance.balance.centValue;
    }), (0, _operators.mergeMap)(function () {
      return (0, _rxjs.from)(_Core["default"].gameController.reset()).pipe((0, _operators.mergeMap)(function () {
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types6.AUTO_PLAY_STOP
        }), (0, _rxjs.of)({
          type: _types3.DIALOG_STATE,
          payload: _DialogState.DialogState.INSUFFICIENT_BALANCE
        }));
      }));
    }));
  });
  _defineProperty(this, "startRoundEpic", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.SPIN_BUTTON), (0, _operators.filter)(function () {
      return (0, _DetermineIfNewRoundCanBestarted.DetermineIfNewRoundCanBeStarted)(store.value) && _Core["default"].gameController.newRound();
    }), (0, _operators.mergeMap)(function (a) {
      if (store.value.com.connectionState === _types.ConnectionState.Reconnecting) {
        console.warn("reconnecting");
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types3.STATUS_TEXT_SET,
          payload: {
            value: _Core["default"].translate("reconnecting")
          }
        }), (0, _rxjs.of)({
          type: _types2.REELS_SPIN
        }), action$.pipe((0, _reduxObservable.ofType)(_types.RECONNECTED), (0, _operators.take)(1), (0, _operators.mapTo)({
          type: _types3.SPIN_BUTTON,
          payload: a.payload
        })));
      }
      var meta = a.payload ? a.payload.roundMetaData : {};
      meta.autoPlay = store.value.autoPlay.on;
      var bet = store.value.bet;
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types.COMMAND_SEND,
        payload: new _SpinRequest.SpinRequest(bet.coins, bet.lines, bet.denomination, meta, null, bet.featureSet)
      }), (0, _rxjs.of)({
        type: _types2.ROUND_START
      }), (0, _rxjs.of)({
        type: _types2.REELS_SPIN
      }), (0, _rxjs.of)({
        type: _types7.UPDATE_BALANCE_BET,
        payload: bet.value
      }),
      // set round id is sent on response when we get a
      (0, _rxjs.of)({
        type: _types2.SLOW_SERVER_RESPONSE
      }).pipe((0, _operators.delay)(_this.SLOW_SERVER_RESPONSE_TIMEOUT), (0, _operators.takeUntil)(action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_RECEIVED)))));
    }));
  });
  /**
   * Trigger spin animations etc to controller.
   * Will check so that its not already spinning.
   */
  _defineProperty(this, "reelsSpin", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.REELS_SPIN), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.from)(_Core["default"].gameController.spin(store.value.game.featureFreeSpins, store.value.game.reconnectSpin)).pipe((0, _operators.mergeMap)(function () {
        var actions = [(0, _rxjs.of)({
          type: _types2.REELS_SPINNING
        }, {
          type: _types2.QUICK_STOP_AVAILABLE
        })];
        if (store.value.game.featureFreeSpins) actions.push((0, _rxjs.of)({
          type: _types2.FREE_SPIN_SPINNING
        }));
        return _rxjs.concat.apply(void 0, actions);
      }));
    }));
  });
  /**
   * Handles dispatching new values of the wincounter, this will ensure we dont exceed games win limit ever.
   * note freespins coins won are not added here, they are added from the resulting payline_win however, other features are.
   */
  _defineProperty(this, "maxWin", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.GAME_MAX_WIN), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.from)(_Core["default"].gameController.maxWin(store.value.config.maxWin)).pipe((0, _operators.mergeMap)(function () {
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types.SKIP_TO_COMMAND,
          payload: {
            type: _CommandType.CommandType.RoundEndResponse
          }
        }), (0, _rxjs.of)({
          type: _types.COMMAND_QUEUE_NEXT
        }));
      }));
    }));
  });
  /**
   * When bet changes we update the current collection based on bet value. note this does not support mulitple collections on same value (with different symbols)
   */
  _defineProperty(this, "updateCollectionOnBet", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types8.UPDATE_BET), (0, _operators.filter)(function () {
      return !!store.value.game.collections;
    }), (0, _operators.mergeMap)(function (a) {
      for (var i = 0; i < store.value.game.collections.length; i++) {
        if (store.value.bet.value === store.value.game.collections[i].betAmount) {
          return (0, _rxjs.of)({
            type: _types2.COLLECTION_UPDATE,
            payload: store.value.game.collections[i]
          });
        }
      }
      return (0, _rxjs.of)({
        type: _types2.COLLECTION_UPDATE,
        payload: undefined
      });
    }));
  });
  /**
   * 
   * @param action$ 
   * @param store 
   * @returns 
   */
  _defineProperty(this, "collectionsHandling", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_PLAY), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.FeatureWinResponse === a.payload.type && [_FeatureAwardType.FeatureAwardType.Collect].indexOf(a.payload.awardType) > -1;
    }), (0, _operators.switchMap)(function (a) {
      var actions = [(0, _rxjs.of)({
        type: _types2.COLLECTIONS_UPDATE,
        payload: a.payload.collections
      })];
      // update the current collection based on current bet.
      for (var i = 0; i < a.payload.collections.length; i++) {
        if (store.value.bet.value === a.payload.collections[i].betAmount) {
          actions.push((0, _rxjs.of)({
            type: _types2.COLLECTION_UPDATE,
            payload: a.payload.collections[i]
          }));
          return _rxjs.concat.apply(void 0, actions);
        }
      }
      return _rxjs.concat.apply(void 0, [(0, _rxjs.of)({
        type: _types2.COLLECTION_UPDATE,
        payload: undefined
      })].concat(actions));
    }));
  });
  /***
   * Tell game skip win line present was triggeredd
   */
  _defineProperty(this, "winLinePresentationStop", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.PRESENTATION_STOP), (0, _operators.filter)(function () {
      return !store.value.blitz.on && !store.value.game.presentationStopAvailable;
    }), (0, _operators.mergeMap)(function (a) {
      // Fire and forget, we do not wait for this.
      _Core["default"].gameController.winLinePresentationStop();
      return _rxjs.EMPTY;
      //    return of({ type: PRESENTATION_STOPPED })
    }));
  });
  /**
   * Detect hyperSpin.
   * @param action$ 
   * @returns 
   */
  _defineProperty(this, "hyperSpinStart", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.SPIN_BUTTON), (0, _operators.filter)(
    // if hs is allowed in config and we are not in blitz mode.
    function (a) {
      return store.value.config.hsAllowed && !store.value.blitz.on;
    }), (0, _operators.bufferTime)(400, null), (0, _operators.mergeMap)(function (a) {
      // this will always fire in doubles, buffer time might not be the smart. but since redcuer will nust not care about second update it wont matter
      // DO NOT put any effects here. and any effects reacting to HYPER_SPIN_START needs to check if hyperSpin is already enabled.
      if (a.length >= 4 && !store.value.game.hyperSpin) {
        return (0, _rxjs.of)({
          type: _types2.HYPER_SPIN_START
        });
      } else if (a.length < 4 && store.value.game.hyperSpin) {
        return (0, _rxjs.of)({
          type: _types2.HYPER_SPIN_STOP
        });
      }
      return _rxjs.EMPTY;
    }));
  });
  /** HELPERS */
  _defineProperty(this, "_checkBigWin", function (coinsWon, betCoinValue, bigwinCfg) {
    return new Promise(function (resolve, reject) {
      //Check if we should trigger bigwin?.
      // might need to be more selective with what features.
      if (bigwinCfg) {
        var level = null;
        if (bigwinCfg.level3 && betCoinValue * bigwinCfg.level3 <= coinsWon) level = 3;else if (bigwinCfg.level2 && betCoinValue * bigwinCfg.level2 <= coinsWon) level = 2;else if (bigwinCfg.level1 && betCoinValue * bigwinCfg.level1 <= coinsWon) level = 1;
        if (level) {
          _Core["default"].dispatch({
            type: _types2.BIGWIN_START
          });
          _Core["default"].gameController.showBigWin(coinsWon, level).then(function () {
            _Core["default"].dispatch({
              type: _types2.BIGWIN_END
            });
            resolve();
          });
        } else {
          resolve();
        }
      } else {
        resolve();
      }
    });
  });
});
//# sourceMappingURL=epics.js.map